export enum CashRewardType {
	BANK = 'bank',
	PAYPAL = 'paypal',
}
